<template>
    <nav class="footer-nav">
        <ul class="list-reset">
            <li>
                <a target="_blank" href="https://www.pixtel.us/about.html">Company</a>
            </li>
            <li>
                <a href="mailto:sales@pixtel.us">Contact</a>
            </li>
            <li>
                <a href="#faqs">FAQ's</a>
            </li>
            <li>
                <a target="_blank" href="https://www.pixtel.us/termsofservice.html">Terms</a>
            </li>
            <li>
                <a target="_blank" href="https://www.pixtel.us/privacypolicy.html">Privacy</a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
  name: 'CFooterNav'
}
</script>
